import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    questions: [],
    total: 0,
    showModalConfirmDisable: false,
    showModalConfirmRemove: false,
    shouldBeRefresh: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_FETCH_QUESTIONS:
            return {
                ...state,
                questions: payload.questions,
                total: payload.total,
            };
        case actions.CHANGE_SHOW_MODAL_DISABLE_QUESTION:
            return { ...state, showModalConfirmDisable: payload };
        case actions.CHANGE_SHOW_MODAL_REMOVE_QUESTION:
            return { ...state, showModalConfirmRemove: payload };
        case actions.CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE:
            return { ...state, shouldBeRefresh: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/questions-database/questions-database.reducer.js